import alasql from "alasql";
import CreateHelper from "../../pages/Create/createHelper";

const helper = {
  multiGroupingData: ({
    Data,
    single_asset_class_style,
    asset_class_length,
  }) => {
    if (Data && Data.length > 0) {
      let groupBy_clssFi_assetCls = alasql(
        "SELECT new_classification, new_style FROM ? GROUP BY new_classification, new_style",
        [Data]
      );
      let styleAssetClassGroups = alasql(
        "SELECT new_classification, fund_asset_class_focus FROM ? GROUP BY fund_asset_class_focus, new_classification",
        [Data]
      );

      let grouped_styleAsset = {};

      if (styleAssetClassGroups && styleAssetClassGroups.length > 0) {
        for (let i = 0; i < styleAssetClassGroups.length; i++) {
          let name = styleAssetClassGroups[i]["new_classification"]
            ? styleAssetClassGroups[i]["new_classification"].toLowerCase()
            : "";
          let val = styleAssetClassGroups[i]["fund_asset_class_focus"];

          if (name in grouped_styleAsset === false) {
            grouped_styleAsset[name] = val;
          }
        }
      }
      // sub-group data
      let grouped_data = {};
      for (let i = 0; i < groupBy_clssFi_assetCls.length; i++) {
        let new_clsssifi = groupBy_clssFi_assetCls[i]["new_classification"];
        if (new_clsssifi in grouped_data === false && new_clsssifi !== null) {
          let style = {};
          let style_name = groupBy_clssFi_assetCls[i]["new_style"];
          style[style_name] = Data.filter(
            (obj) =>
              obj["new_style"] === style_name &&
              obj["new_classification"] === new_clsssifi
          );

          grouped_data[new_clsssifi] = {
            ...style,
          };
        } else if (new_clsssifi !== null) {
          let style = {
            ...grouped_data[new_clsssifi],
          };
          let style_name = groupBy_clssFi_assetCls[i]["new_style"];
          style[style_name] = Data.filter(
            (obj) =>
              obj["new_style"] === style_name &&
              obj["new_classification"] === new_clsssifi
          );

          grouped_data[new_clsssifi] = {
            ...style,
          };
        } else {
          continue;
        }
      }

      // --------if asset class has only on type follow this------------
      let groupBy_new_style = alasql("SELECT * FROM ? GROUP BY new_style", [
        Data,
      ]);
      let group_based_on_style = {};

      for (let i = 0; i < groupBy_new_style.length; i++) {
        let name = groupBy_new_style[i]["new_style"];
        let filtered = Data.filter((e) => e.new_style === name);
        group_based_on_style[name] = filtered;
      }

      let tableData2 = [
        {
          "column-1": [],
          "column-2": [],
          "column-3": [],
        },
      ];
      let _clm = "column-1";
      for (let style in group_based_on_style) {
        if (style.toLocaleLowerCase() === "cash") {
          _clm = "column-3";
        }
        tableData2[0][_clm].push({
          subheading: style,
          classification: group_based_on_style[style][0]["new_classification"],
          assetClass: group_based_on_style[style][0]["fund_asset_class_focus"],
        });
        for (let j = 0; j < group_based_on_style[style].length; j++) {
          tableData2[0][_clm].push(group_based_on_style[style][j]);
        }
        // secondLevelCount++;
        if (_clm === "column-1") {
          _clm = "column-2";
        } else if (_clm === "column-2") {
          _clm = "column-3";
        } else if (_clm === "column-3") {
          _clm = "column-1";
        }
      }
      // -----------------------*** ----------------------
      // final table data
      let tableData = [
        {
          "column-1": [],
          "column-2": [],
          "column-3": [],
        },
      ];

      let column = "column-1";
      let classBaseCount = 0;
      let secondLevelBaseCount = 0;
      let classification_count = 0;
      let secondLevelCount = 0;

      let len = Object.keys(grouped_data).length;
      let divide = 3;
      let classifi_avg = Math.round(len / divide);

      let c1_count = 0;
      let c2_count = 0;
      let c3_count = 0;
      let current_count_style = 0;
      let cash_row = [];

      for (let i in grouped_data) {
        let itemLen = Object.keys(grouped_data[i]).length;
        secondLevelBaseCount = secondLevelBaseCount + itemLen;
        classBaseCount++;
      }

      let symbol_order = {};
      for (let classifi in grouped_data) {
        // if (classifi.toLowerCase() === "cash") {
        //   column = "column-3";
        // }
        let _classifi = classifi.toLowerCase();

        if (_classifi === "cash") {
          cash_row.push({
            heading: classifi,
            asset_class: grouped_styleAsset[classifi.toLocaleLowerCase()],
          });
        } else {
          tableData[0][column].push({
            heading: classifi,
            asset_class: grouped_styleAsset[classifi.toLocaleLowerCase()],
          });
        }

        current_count_style = 0;

        for (let style in grouped_data[classifi]) {
          if (_classifi === "cash") {
            cash_row.push({
              subheading: style,
              classification: classifi,
            });
          } else {
            tableData[0][column].push({
              subheading: style,
              classification: classifi,
            });
          }

          for (let j = 0; j < grouped_data[classifi][style].length; j++) {
            if (_classifi === "cash") {
              cash_row.push(grouped_data[classifi][style][j]);
              symbol_order[grouped_data[classifi][style][j]["symbol"]] = j + 1;
            } else {
              tableData[0][column].push(grouped_data[classifi][style][j]);
              symbol_order[grouped_data[classifi][style][j]["symbol"]] = j + 1;
            }
          }
          secondLevelCount++;
          current_count_style++;
        }

        classification_count++;

        if (column === "column-1" && _classifi !== "cash") {
          c1_count = c1_count + current_count_style + 1;
          if (c1_count <= c2_count && c1_count <= c3_count) {
            column = "column-1";
          } else if (c2_count <= c1_count) {
            column = "column-2";
          } else if (c3_count < c1_count && c3_count < c2_count) {
            column = "column-3";
          }
        } else if (column === "column-2" && _classifi !== "cash") {
          c2_count = c2_count + current_count_style + 1;
          if (c2_count < c1_count && c2_count < c3_count) {
            column = "column-2";
          } else if (c3_count <= c2_count) {
            column = "column-3";
          } else if (c1_count <= c2_count && c1_count <= c3_count) {
            column = "column-1";
          }
        } else if (column === "column-3" && _classifi !== "cash") {
          c3_count = c3_count + current_count_style + 1;
          if (c3_count < c1_count && c3_count < c2_count) {
            column = "column-3";
          } else if (c1_count <= c3_count) {
            column = "column-1";
          } else if (c2_count < c1_count && c2_count < c3_count) {
            column = "column-2";
          }
        } else {
          column = "column-1";
        }
      }

      cash_row.map((obj) => tableData[0]["column-3"].push(obj));
      // }
      let fund_asset_class_focus_filtered = asset_class_length
        ? asset_class_length
        : Data.map((e) => e.fund_asset_class_focus).filter(
            (a, i, arr) =>
              arr.indexOf(a) === i &&
              a !== null &&
              a !== undefined &&
              a.toLowerCase() !== "cash"
          );
      //------------ **----------------------
      let final_table_data =
        single_asset_class_style === true &&
        fund_asset_class_focus_filtered.length === 1
          ? tableData2
          : tableData;
      return {
        grouped_data: final_table_data,
        styleAssetClassGroups: grouped_styleAsset,
        symbol_order,
      };
    }
  },
  assetClassSliderValidation: ({
    asset_class,
    symbols,
    upper_bounds,
    setFundTypeStyleError,
    universeLiteValidation,
    ownSecurityUniverse,
  }) => {
    let final_data = [];

    if (asset_class && asset_class.length && symbols && symbols.length) {
      for (let i = 0; i < asset_class.length; i++) {
        let name = asset_class[i]["name"];
        let slider_max = Math.round(asset_class[i]["max"] * 100);

        let filter_symbols = symbols.filter(
          (e) => e.fund_asset_class_focus === name
        );
        let sum = CreateHelper.ADD(filter_symbols);

        let condition;

        if (ownSecurityUniverse) {
          //own security universe

          condition =
            CreateHelper.securityValidate_universe_lite({
              maxLength: filter_symbols.length,
              slider_max_value: slider_max,
              tuner_max_limit: upper_bounds,
            }) && sum <= slider_max;
        } else if (universeLiteValidation) {
          //universe lite condition
          condition =
            CreateHelper.securityValidate_universe_lite({
              maxLength: filter_symbols.length,
              slider_max_value: slider_max,
              tuner_max_limit: upper_bounds,
            }) && sum <= slider_max;
        } else {
          // universe condition
          condition =
            CreateHelper.securityValidate({
              maxLimit: upper_bounds,
              tableLength: filter_symbols.length,
              individualSliderVal: slider_max,
            }) && sum <= slider_max;
        }

        if (condition) {
          final_data.push({ ...asset_class[i], slider_error: false });
        } else {
          final_data.push({ ...asset_class[i], slider_error: true });
          setFundTypeStyleError(true);
        }
      }
    }
    return final_data;
  },
  classificationSliderValidation: ({
    classification,
    symbols,
    upper_bounds,
    setFundTypeStyleError,
    universeLiteValidation,
    ownSecurityUniverse,
  }) => {
    let final_data = [];

    if (classification && classification.length && symbols && symbols.length) {
      for (let i = 0; i < classification.length; i++) {
        let name = classification[i]["name"];
        let slider_max = Math.round(classification[i]["max"] * 100);

        let filter_symbols = symbols.filter(
          (e) => e.new_classification === name
        );
        let sum = CreateHelper.ADD(filter_symbols);

        let condition;

        if (ownSecurityUniverse) {
          //own security universe
          condition =
            CreateHelper.securityValidate_universe_lite({
              maxLength: filter_symbols.length,
              slider_max_value: slider_max,
              tuner_max_limit: upper_bounds,
            }) && sum <= slider_max;
        } else if (universeLiteValidation) {
          //universe lite condition
          condition =
            CreateHelper.securityValidate_universe_lite({
              maxLength: filter_symbols.length,
              slider_max_value: slider_max,
              tuner_max_limit: upper_bounds,
            }) && sum <= slider_max;
        } else {
          // universe condition
          condition =
            CreateHelper.securityValidate({
              maxLimit: upper_bounds,
              tableLength: filter_symbols.length,
              individualSliderVal: slider_max,
            }) && sum <= slider_max;
        }

        if (condition) {
          final_data.push({ ...classification[i], slider_error: false });
        } else {
          final_data.push({ ...classification[i], slider_error: true });
          setFundTypeStyleError(true);
        }
      }
    }
    return final_data;
  },
  styleSliderValidataion: ({
    styles,
    symbols,
    upper_bounds,
    setFundTypeStyleError,
    universeLiteValidation,
    ownSecurityUniverse,
  }) => {
    let final_data = [];
    if (styles && styles.length && symbols && symbols.length) {
      for (let i = 0; i < styles.length; i++) {
        let name = styles[i]["style"];
        let slider_max = Math.round(styles[i]["max"] * 100);

        let filter_symbols = symbols.filter((e) => e.new_style === name);
        let sum = CreateHelper.ADD(filter_symbols);

        let condition;

        if (ownSecurityUniverse) {
          //own security universe
          condition =
            CreateHelper.securityValidate_universe_lite({
              maxLength: filter_symbols.length,
              slider_max_value: slider_max,
              tuner_max_limit: upper_bounds,
            }) && sum <= slider_max;
        } else if (universeLiteValidation) {
          //universe lite condition
          condition =
            CreateHelper.securityValidate_universe_lite({
              maxLength: filter_symbols.length,
              slider_max_value: slider_max,
              tuner_max_limit: upper_bounds,
            }) && sum <= slider_max;
        } else {
          // universe condition
          condition =
            CreateHelper.securityValidate({
              maxLimit: upper_bounds,
              tableLength: filter_symbols.length,
              individualSliderVal: slider_max,
            }) && sum <= slider_max;
        }

        if (condition) {
          final_data.push({ ...styles[i], slider_error: false });
        } else {
          final_data.push({ ...styles[i], slider_error: true });
          setFundTypeStyleError(true);
        }
      }
    }

    return final_data;
  },
};

export default helper;



// WEBPACK FOOTER //
// ./src/components/common/treeTableWithSlider/helper.js